// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LxOq2","option":"styles_option__1WVvQ","active":"styles_active__312bR"};